import { NgModule, Type } from '@angular/core';

import { CommonModule } from '@angular/common';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { FormsModule } from '@angular/forms';
import { IMEEventDirectiveModule } from '../ime-event-directive/ime-event.module';
import { SearchBoxComponent } from './search-box.component';

const components: Type<any>[] = [SearchBoxComponent];

@NgModule({
  imports: [CommonModule, FontAwesomeModule, FormsModule, IMEEventDirectiveModule],
  declarations: [components],
  exports: [components],
})
export class SearchBoxModule { }
